var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "reports-page-container" } },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { staticClass: "px-md-5", attrs: { cols: "12" } },
            [
              _c("page-header", {
                attrs: {
                  title: _vm.$t("application-reports.title").toString(),
                  subtitle: _vm.$t("application-reports.subtitle").toString(),
                  "title-class": "page-header text-capitalize",
                },
              }),
              _vm._v(" "),
              _c("reports-tabs"),
              _vm._v(" "),
              _c("router-view", {
                ref: "reportContainer",
                attrs: {
                  loading: _vm.loading,
                  "running-report": _vm.runningReport,
                },
                on: { "run-report": _vm.handleRunReport },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("unsynced-apps-modal", {
        ref: "unsyncedAppsModal",
        attrs: { "nr-of-unsynced-apps": _vm.nrOfUnsyncedApps },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }